import React from 'react';
import DatePicker from 'react-datepicker';
import { ru } from 'date-fns/locale';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

import 'react-datepicker/dist/react-datepicker.css';

type DatePickerFieldProps = {
  label: string;
  selected: Date | null;
  onChange: (date: Date | null) => void;
  disabled?: boolean;
  className?: string;
  minDate?: Date | null;
  maxDate?: Date | null;
  filterDate?: (date: Date) => boolean;
};

export const DatePickerField: React.FC<DatePickerFieldProps> = ({
  label,
  selected,
  onChange,
  disabled,
  className,
  minDate,
  maxDate,
  filterDate,
}) => {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <div className="relative w-full">
        <DatePicker
          locale={ru}
          selected={selected}
          onChange={(d: Date | null) => onChange(d)}
          disabled={disabled}
          dateFormat="dd.MM.yyyy"
          placeholderText="дд.мм.гггг"
          minDate={minDate || undefined}
          maxDate={maxDate || undefined}
          filterDate={filterDate}

          portalId="datepicker-portal"
          popperClassName="!z-[9999]"

          className={`w-full rounded-md border py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-2 border-gray-300 focus:ring-blue-500 ${
            disabled ? 'cursor-not-allowed border-gray-200 bg-gray-100 text-gray-500' : ''
          }`}
          wrapperClassName="w-full"
          showPopperArrow={false}
        />
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400">
          <CalendarTodayIcon className="h-5 w-5" />
        </div>
      </div>
    </div>
  );
};